import React from 'react';
import { Loading, PanelHeader } from 'js/components';
import { Card, CardBody } from 'reactstrap';
import { useParams } from 'react-router-dom';
import UserGroupStatCard from 'js/routes/ProductManagers/components/ProductManager/UserGroupStatCard';
import { Link } from 'react-router-dom';
import { Icon } from 'js/components';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';

function ProductManagementDashboard({
  capabilitySets,
  capabilitySetsHaveLoaded,
  myUserGroups = [],
  myUserGroupsHaveLoaded = false,
}) {
  const { workspaceId } = useParams();

  return (
    <div>
      <PanelHeader size="sm" />
      <div className="content">
        <div className="row">
          <div className="col-sm-12 col-md-8">
            {myUserGroupsHaveLoaded ? (
              myUserGroups.length > 0 ? (
                <div>
                  {myUserGroups.map((item) => (
                    <UserGroupStatCard
                      key={item.user_group.id}
                      userGroup={item.user_group}
                      isFavorited={item.is_favorited}
                      isPmFor={item.is_pm_for}
                    />
                  ))}
                </div>
              ) : (
                <Card>
                  <CardBody className="media text-muted">
                    <Icon
                      icon={['far', 'star-exclamation']}
                      size="4x"
                      className="mr-3"
                      fixedWidth
                    />
                    <div className="media-body">
                      <p>You don't have any favorite user groups yet.</p>
                      <p>
                        Mark some user groups as favorites and you'll get a
                        summary of their recent activity here, so you can keep
                        up to date on their progress at a glance.
                      </p>
                      <p>
                        <Link to={`/w/${workspaceId}/pm/user-groups`}>
                          Add some user groups to your favorites now
                        </Link>
                      </p>
                    </div>
                  </CardBody>
                </Card>
              )
            ) : (
              <Card>
                <CardBody className="media text-muted">
                  <Loading />
                </CardBody>
              </Card>
            )}
          </div>
          <div className="col-sm-12 col-md-4">
            <Card>
              {/* <CardHeader>
                <CardTitle tag="h5">Capability sets</CardTitle>
              </CardHeader> */}
              <CardBody>
                <h6>Capability Sets</h6>
                {!capabilitySetsHaveLoaded ? null : capabilitySets.length >
                  0 ? (
                  capabilitySets.map((cs) => (
                    <div key={cs.id}>
                      <Link
                        to={`/w/${workspaceId}/pm/capability-sets/${cs.id}`}
                      >
                        {cs.name}
                      </Link>
                    </div>
                  ))
                ) : (
                  <div className="text-muted">
                    <p>You don't have any capability sets yet.</p>
                    <p>
                      <Link
                        to={`/w/${workspaceId}/pm/capability-sets/new`}
                        className="btn btn-primary"
                      >
                        <Icon icon={faPlus} className="icon-left" />
                        Create a new capability set
                      </Link>
                    </p>
                  </div>
                )}
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );

  // return <Redirect to={`/w/${workspaceId}/pm/capability-sets`} />;
}

export default ProductManagementDashboard;
